import lodash from 'lodash';
import {en} from './en';
import {sk} from './sk';

const Translations = {
	en,
	sk,
};


let language = window.localStorage.getItem('language');

if (!language) {
	language = (navigator.languages && navigator.languages[0]) ||
		navigator.language ||
		navigator.userLanguage;

	if (/^sk\b/.test(language))
		language = 'sk';
	else
		language = 'en';
}

window.language = language;
window.localStorage.setItem('language', language);


export const tr = key => lodash.get(Translations, `${window.language}.${key}`);

export const Translatable = {
	methods: {
		tr(key) {
			return tr(key);
		},
		currentLanguage() {
			return window.language;
		},
		setCurrentLanguage(language) {
			window.language = language;
			window.localStorage.setItem('language', language);
		}
	},
	computed: {
		languages() {
			return Object.keys(Translations);
		}
	},
};
